import React, { useEffect, useState } from 'react';

import {
  Container,
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  Button,
  InputGroup,
  InputGroupAddon,
  Input,
  InputGroupText
} from 'reactstrap';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from '../../../components/Pagination';
import SpyService from '../service';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import ModalConfirmation from '../../../components/Modal/ConfirmationModal';
import useVoiceChannels from 'hooks/useVoiceChannels';

import {
  icon_column_style,
  individual_column_style,
  individual_header_style,
  individual_icon_header_style
} from '../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';

const GroupSpyList = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  const [GroupExitRoute, setGroupExitRoute] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [seachSpy, setSeachSpy] = useState();
  const [idResource, setidResource] = useState();
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);

  const { options: voiceChannelOptions } = useVoiceChannels();

  useEffect(() => {
    getGroup();
  }, []);

  const getGroup = (selectedPage = 1) => {
    SpyService.getAll(selectedPage, 10)
      .then((res) => {
        const { data, totalRegisters } = res.data;
        const newActivePage = selectedPage || activePage;

        setGroupExitRoute(data);
        setQuantity(totalRegisters);
        setActivePage(newActivePage);
        setLoading(false);
      })
      .catch(() => {
        toast.error('Não foi possivel os grupos de rota de saída', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const handlePageChange = (activePage) => {
    getGroup(activePage);
  };

  function getGroupSeach(event, selectedPage = 1) {
    setSeachSpy(event.target.value);
    if (seachSpy) {
      SpyService.getAllSeach(selectedPage, 10, event.target.value, false)
        .then((res) => {
          const { data, totalRegisters } = res.data;
          const newActivePage = selectedPage || activePage;
          setGroupExitRoute(data);
          setQuantity(totalRegisters);
          setActivePage(newActivePage);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Não foi possivel listar os espiões', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    }
  }

  function deleteGroup(id) {
    SpyService.delete(id)
      .then(() => {
        toast.success('Grupo de Rotas de Saída excluido com sucesso', {
          autoClose: 3000,
          closeOnClick: true
        });
        getGroup();
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        getGroup();
      });
  }

  const controlDelete = (id) => {
    setidResource(id);
    setOpenModalConfirmation(true);
  };

  function handleUpdate(id) {
    history.push(`GroupExitRoute/form/${id}`);
  }

  return (
    <>
      <SimpleHeader
        setCreate="/admin/GroupExitRoute/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Grupo de Rotas de Saída</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="11">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Buscar grupo de rota de saída por nome"
                          type="text"
                          onChange={(event) => getGroupSeach(event)}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={GroupExitRoute}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },

                    {
                      dataField: 'voice_channel_id',
                      text: 'Canal de Voz',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      formatter: (cell) => {
                        const channel = voiceChannelOptions.find(
                          (opt) => opt.value === cell
                        );
                        return channel ? channel.label : cell || '-';
                      }
                    },

                    {
                      dataField: 'customized_group',
                      text: 'Grupo Customizado',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      formatter: (customized_group) => {
                        return customized_group ? 'Sim' : 'Não';
                      }
                    },
                    {
                      dataField: 'first_out_trunk.name',
                      text: 'Saída principal',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'first_time',
                      text: 'Tempo de toque',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'second_out_trunk.name',
                      text: 'Saída 2',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'second_time',
                      text: 'Tempo de toque',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'third_out_trunk.name',
                      text: 'Saída 3',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'third_time',
                      text: 'Tempo de toque',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },

                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',

                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            onClick={() => handleUpdate(row.id)}
                            size="sm"
                          >
                            <li className="fas fa-user-edit"></li>
                          </Button>
                        );
                      }
                    },

                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'deletar',

                      formatter: (_, row) => {
                        return (
                          <Button
                            color="danger"
                            onClick={() => controlDelete(row.id)}
                            size="sm"
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idResource}
        deleteResource={deleteGroup}
        message={'Tem certeza que deseja excluir o Grupo?'}
      />
    </>
  );
};

export default GroupSpyList;
